import { useCallback, useEffect } from 'react';
import { ApplicationEvent } from '../../models/analytics';
import { useAnalytics } from './AnalyticsProvider';
import {
  ParentApplicationEvent,
  ParentMessenger,
  parentMessenger,
} from './ParentApplicationEventMessenger';

type UsePageViewEventsPayload = {
  applicationEvent?: ApplicationEvent;
  parentApplicationEvent?: ParentApplicationEvent;
  messenger?: ParentMessenger;
};

export const useApplicationEvent = ({
  applicationEvent,
  parentApplicationEvent,
  messenger = parentMessenger,
}: UsePageViewEventsPayload = {}) => {
  const { tinklinkAnalytics: analytics } = useAnalytics();

  const sendEvent = useCallback(
    (event: ApplicationEvent, parentEvent?: ParentApplicationEvent) => {
      analytics.sendApplicationEvent(event);

      if (parentEvent) messenger?.fireApplicationEvent(parentEvent);
    },
    [analytics, messenger]
  );

  useEffect(() => {
    if (applicationEvent) sendEvent(applicationEvent, parentApplicationEvent);
  }, [applicationEvent, parentApplicationEvent, sendEvent]);

  return {
    analytics,
    sendEvent,
  };
};
